import ApiClient from "./ApiClient";

export const getMatch = ({ id }) => ApiClient.get(`/matches/${id}`);
